import {
  IDynamicFormTypes,
  IKaseMasterName,
  MasterNameInvolvement,
} from './kase';
import { IMasterNameRelationBehavior } from './master.names';

export interface IKaseMasterNameRelationship {
  behavior?: IMasterNameRelationBehavior | null;
  involvement: MasterNameInvolvement[];
}
export type IKaseInvolvement = {
  behavior?: IMasterNameRelationBehavior;
  involvement?: MasterNameInvolvement[];
};

export enum AgeGroup {
  EXACT_AGE = 'EXACT_AGE',
  AGE_RANGE = 'AGE_RANGE',
  OVER_NINETY_EIGHT_YEARS_OLD = 'OVER_NINETY_EIGHT_YEARS_OLD',
  UNKNOWN = 'UNKNOWN',
}

export enum OffenderType {
  SUSPECT = 'SUSPECT',
  ACCOMPLICE = 'ACCOMPLICE',
  CLEARED = 'CLEARED',
  CHARGED = 'CHARGED',
}

export enum OffenderCondition {
  APPEARS_TO_BE_IMPAIRED_WITH_DRUGS = '01',
  APPEARS_TO_BE_IMPAIRED_WITH_ALCOHOL = '02',
  APPEARS_TO_BE_MENTALLY_DISORDERED = '03',
  APPEARS_TO_BE_INJURED_OR_ILL = '04',
  APPARENTLY_NORMAL = '05',
  NOT_REPORTED = '88',
  UNKNOWN = '99',
}

export type IAgeFields = {
  ageGroup: AgeGroup;
  age?: number;
  ageRange?: [number, number];
};

export type kaseWitnessForm = IAgeFields & {
  wasInterviewed: boolean;
  residenceStatus: string;
  wasArrested?: number;
};

export type kaseOffenderForm = IAgeFields & {
  offenderType: OffenderType;
  wasArrested?: number;
  offenderCondition: OffenderCondition;
  residenceStatus: string;
};

export type kaseVictimForm = kaseWitnessForm & {
  victimType: string;
  interviewedBy: string;
  wasArrested?: number;
  levelOfInjury: string;
  injuryType: string;
  medicalTreatment: string;
  officerActivity: string;
  officerAssignmentType: string;
  officerOriJurisdiction: string;
};

export type IKaseInvolvementForm = IKaseInvolvement & {
  _id?: string | null; // TODO: test this , possible fuckery
  wasArrested?: number;
} & (kaseOffenderForm | kaseVictimForm | kaseWitnessForm);

export const KaseInvolvementFormMap: Partial<
  Record<MasterNameInvolvement, IDynamicFormTypes>
> = {
  [MasterNameInvolvement.DEFENDANT]: 'OFFENDER',
  [MasterNameInvolvement.SUSPECT]: 'OFFENDER',
  [MasterNameInvolvement.VICTIM]: 'VICTIM',
  [MasterNameInvolvement.COMPLAINANT_VICTIM]: 'VICTIM',
  [MasterNameInvolvement.WITNESS]: 'WITNESS',
};

export const getKaseInvolvementFormNames = (
  involvement: MasterNameInvolvement[],
): IDynamicFormTypes[] => {
  return [
    ...new Set(
      involvement
        .map((value) => KaseInvolvementFormMap[value])
        .filter((value): value is IDynamicFormTypes => Boolean(value)),
    ),
  ];
};

export interface IBulkUpdateItem {
  masterNameId: string;
  relationship: IKaseInvolvement;
  additionalInfo?: Record<string, any>;
}

export interface IBulkUpdateResult {
  masterNameId: string;
  success: boolean;
  data?: IKaseMasterName;
  error?: string;
}

export interface IBulkUpdateResponse {
  results: IBulkUpdateResult[];
}
